// extracted by mini-css-extract-plugin
module.exports = {"wrap":"FileUpload_wrap__2V0o_","disabled":"FileUpload_disabled__kY7kd","input":"FileUpload_input__3Dj5F","addIcon":"FileUpload_addIcon__3NnAw"};